import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";
// Install global axios hardening (45s timeout · auto-attached auth header ·
// 401 → /auth?returnTo recovery · friendly network-error toast). Side-effect
// import — pulled here at startup so every component inherits the behavior.
import "@/lib/api";
// Iter 163 · Global 402→EntitlementRequiredError interceptor so any
// gated endpoint degrades gracefully instead of leaking raw JSON into JSX.
import { installAxiosInterceptors } from "@/lib/axios-interceptors";
installAxiosInterceptors();

// Optional error monitoring — no-op when REACT_APP_SENTRY_DSN is not set.
initSentry();

// Silence the benign "ResizeObserver loop" browser warning so it doesn't trip
// the CRA dev-server error overlay (dev-only noise; not a real runtime error).
const RO_LOOP = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener("error", (e) => {
  if (e?.message && RO_LOOP.test(e.message)) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (overlay) overlay.style.display = "none";
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker (offline support + installability).
// Skipped for headless browsers (navigator.webdriver) so the build-time
// prerenderer and automated tests never capture SW-cached responses.
if ("serviceWorker" in navigator && !navigator.webdriver) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* SW registration is best-effort; the app works without it. */
    });
  });
}
